module.exports = __webpack_public_path__ + "static/media/popular4.a6c7a633.png";